export default __webpack_public_path__ + "static/media/twitterLogo.494594bf.svg";